module.exports = __webpack_public_path__ + "img/jacobus_05.18472cbc.png";